import { Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconButtonComponent } from '@components/buttons/icon-button/icon-button.component';
import { TagButtonComponent } from '@components/buttons/tag-button/tag-button.component';
import { Episode, ProgramWithSeasons } from '@shared/graphql/api.generated';
import { GeneralService } from '@shared/services/general.service';

@Component({
  selector: 'app-product-info-desktop',
  imports: [RouterLink, TagButtonComponent, IconButtonComponent],
  templateUrl: './product-info-desktop.component.html',
  styleUrls: ['./product-info-desktop.component.scss'],
})
export class ProductInfoDesktopComponent {
  ProgramData = input.required<ProgramWithSeasons>();
  Episode = input<Episode>();

  private generalService = inject(GeneralService);

  handleNavigateToAboutSection() {
    if (this.generalService.isBrowserOnly) {
      const aboutSection = document.getElementById('product-about-container');
      if (aboutSection) {
        aboutSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  }

  handleSeasonTitle() {
    if (this.Episode()) {
      return this.ProgramData().seasons.filter((item) => item?.id === this.Episode()?.seasonID)[0]
        ?.title;
    } else {
      return this.ProgramData().seasons[0]?.title;
    }
  }
}
